export enum ViewPreferenceType {
    NotArchived = 0,
    Archived = 1,
    All = 2
}